import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import mslPage from "./components/mslPage";
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'
// import VueTianditu from "vue-tianditu";
// import 'default-passive-events'

Vue.use(ElementUI);
Vue.component('mslPage', mslPage)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false
// Vue.use(VueTianditu, {
//   v: "3.1",
//   tk: "64b4329e39f231dbf79149f3196a81df"
// });

// 全局调用mixin
Vue.mixin({
  data() {
    return {

    }
  },
  methods: {
    errToast(str) {
      if (!str) str = '获取数据失败，请刷新重试'

      this.$dialog.alert({
        title:'提示',
        message:str,
        confirmButtonColor:'red'
      })
    },
    successToast(str) {
      this.$dialog.alert({
        title:'提示',
        message:str,
        confirmButtonColor:'green'
      })
    },
    checkPhone(phones) {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(phones)) {
        return false;
      } else {
        return true;
      }
    },
    checkEmail(mail) {
      var myreg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/;
      if (!myreg.test(mail)) {
        return false;
      } else {
        return true;
      }
    }

  },
  mounted() {
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

